import React from "react";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Layout from "../Layout";
import {
  ShowChart,
  Translate,
  People,
  Description,
  GetApp,
  Settings,
} from "@material-ui/icons";
import MenuBookIcon from "@material-ui/icons/MenuBook";

import Copyright from "../../../Components/Copyright";
import useError from "Hooks/useError";
import { message } from "constants/message";

import Axios from "axios";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "2.5em",
    color: "#556cd6",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  wrapper: {
    margin: theme.spacing(2),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(2),
  },
  toast: {
    width: "100%",
  },
  messsageWrapper: {
    marginTop: theme.spacing(2),
  },
}));

function ListItemLink(props) {
  return <ListItem button component={Link} {...props} />;
}

export default function SignIn(props) {

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - メニュー";
  }, []);

  // React.useEffect(() => {
  // }, []);


  const classes = useStyles();

  return (
    <Layout
      content={
        <Grid>
          <Typography variant="h6" color="primary">
            メニューを選択してください
          </Typography>
        </Grid>
      }
    />
  );
}
